import Container from "./containers/Container";

const Nft = {
    Container,
}

export {Nft}